import React, { useState, useEffect } from 'react';
import { IoMdEye } from 'react-icons/io';
import { CiEdit } from 'react-icons/ci';
import { MdDelete } from "react-icons/md";
import { FaUserLock } from "react-icons/fa";
import { Button, Pagination } from '@mui/material';
import { json, useNavigate } from 'react-router-dom';
import ViewAllEmployees from '../../../component/b2c/models/ViewAllEmployee';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../component/b2c/navBar/navBar';
import PaginationItem from '@mui/material/PaginationItem';
import '../../../css/custom-scrollbar.css';
import { HiUsers } from "react-icons/hi";
import { toast } from 'react-toastify';
import { Base_Url, AllEmployeeList,deleteEpmloyee } from '../../../config/config';
import SetPermission from '../../../component/b2c/models/setPermissionModel';

const AllEmployee = () => {
  const [totalOrders, setTotalOrders] = useState(0);
  const { isDarkMode } = useMyContext();
  const [isPopupOpenPermission, setIsPopupOpenPermission] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { isToggleSidebar } = useMyContext();
  const [employee, setEmployee] = useState([]);
  const [empLoyeePermission, setEmployeePermission] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const itemsPerPage = 8;

  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10); 

  useEffect(() => {
    fetchWarehouses();
  }, [page, limit,setEmployee]); 


  const fetchWarehouses = async () => {
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    try {
      const pageNumber = Number(page) || 1;
      const limitNumber = Number(limit) || 10;
      const url_for_allEmployee = `${Base_Url}${AllEmployeeList}?page=${pageNumber}&limit=${limitNumber}`
      const response = await fetch(url_for_allEmployee, {
        method: 'GET',
        headers: {
        'token': token,
            'cus_id': cusid,
            'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (result.status === "SUCCESS") {
        setEmployee(result.data);
        setTotalOrders(result.pagination.totalItems || 0);
      } else {
      }
    } catch (error) {
    }
  };


  const handlePaginationChange = (event, value) => {
    setPage(value);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };
  

  const handleViewClick = (employee) => {
    setSelectedEmployee(employee);
    setIsPopupOpen(true);
  };


  const handleClose = () => {
    setIsPopupOpen(false);
  };


  const handleViewPermissionPopup =(employee) =>{
    setIsPopupOpenPermission(true);
    setEmployeePermission(employee);

  }

  const handleClosePermissionPopup = () => {
    setIsPopupOpenPermission(false);
  };


  const handleNavigation = () => {
    navigate('/dashboard');
  };

  const handleDelete = async (id) => {
    const urldelete = Base_Url + deleteEpmloyee;
  
    try {
      const token = localStorage.getItem('token');
      const cusid = localStorage.getItem('cus_id');
  
      const response = await fetch(`${urldelete}/${id}`, {
        method: 'GET', 
        headers: {
          token,
          cus_id: cusid,
          'Content-Type': 'application/json',
        },
      });
  
      const data = await response.json();
  
      if (data.status === "success") {
        setEmployee((prevWarehouses) => prevWarehouses.filter(employee => employee.id !== id));
        toast.success(data.message);
        setTotalOrders((prev) => prev - 1);
        fetchWarehouses();
    
      } else {
        toast.error( data.message);
      }
  
    } catch (error) {
      toast.error( error.message);
    }
  };

  return (
    <>
      <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
        <div className="z-10">
          <NavBar />
        </div>

        <div className="flex flex-1 overflow-hidden">
          {isToggleSidebar && (
            <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
            style={
              window.innerWidth < 768 
                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                : {}
            }>
              <Sidebar />
            </div>
          )}

          <div className={`shadow-custom-light overflow-x-hidden ml-4 mt-6 mb-6 mr-6 w-full rounded-custom overflow-y-auto dark:shadow-custom-dark p-4 ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : ''}`}>

            <button onClick={handleNavigation}
              className="text-xl w-full sm:text-2xl font-bold mb-4 sm:mb-6 bg-customPurple hover:bg-purple-700 text-white font-sans px-2 sm:px-4 py-2 sm:py-1 rounded h-[40px]  sm:w-full flex items-center justify-center">
              <HiUsers className="mr-2" size={24} />
              All Employee
            </button>

            <div className="overflow-x-auto">
              <table className="min-w-full w-full table-auto">
                <thead className="bg-[#0540a6dd] text-white text-[14px]">
                  <tr className='bg-[#0540a6dd] text-white border border-[#aba7a7]'> 
                    <th className="p-2 text-left w-1/12">Id</th>
                    <th className="p-2 text-left w-2/12">Name</th>
                    <th className="p-2 text-left w-3/12">Email</th>
                    <th className="p-2 text-left w-2/12">Phone</th>
                    <th className="p-2 text-left w-2/12 pl-16">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {employee.reverse().map((employee, index) => (
                    <tr key={employee.id} className="w-full">
                      <td className="p-2">{employee.id}</td>
                      <td className="p-2">{employee.name}</td>
                      <td className="p-2">{employee.email}</td>
                      <td className="p-2">{employee.phone}</td>
                      <td className="p-2">
                        <div className="flex space-x-2">
                          <Button variant="contained" size="small" color="primary" onClick={() => handleViewClick(employee)}>
                            <IoMdEye />
                          </Button>
                          <Button variant="contained" size="small" color="secondary" >
                            <CiEdit />
                          </Button>
                          <Button variant="contained" size="small" color="error"
                          onClick={() => handleDelete(employee.employee_id)} >
                            <MdDelete />
                          </Button>
                          <Button variant="contained" size="small" color= "inherit"onClick={() => handleViewPermissionPopup(employee)} >
                            <FaUserLock />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                <span className="text-sm text-gray-700 font-bold dark:text-gray-300">{`Total Employee: ${totalOrders}`}</span>
                <select
                  id="limit"
                  value={limit}
                  onChange={handleLimitChange}
                  className="border rounded p-1 sm:ml-[480px] text-sm bg-white dark:bg-darkmodeColor dark:text-gray-200"
                >
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  {/* <option value={50}>50</option> */}
                  <option value={totalOrders}>All</option>
                </select>
                <Pagination
                  count={Math.ceil(totalOrders / limit)}
                  page={page}
                  onChange={handlePaginationChange}
                  variant="outlined"
                  shape="rounded"
                  className="pagination"
                  size="small"
                  renderItem={(item) => (
                    <PaginationItem
                      {...item}
                      className={`mx-1 rounded-md ${item.selected ? 'bg-customPurple text-white' : 'text-gray-700 dark:text-gray-300'} hover:bg-purple-700 hover:text-white`}
                    />
                  )}
                />
              </div>
          </div>
        </div>
        <ViewAllEmployees isopen={isPopupOpen} onClose={handleClose} employee={selectedEmployee} />
        <SetPermission isopen={isPopupOpenPermission} onClose= {handleClosePermissionPopup } selectedEmpForSetPermission={empLoyeePermission}/>
      </div>
    </>
  );
};

export default AllEmployee;
